import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import QuickIssues from "./components/QuickIssues";
import IssuesFilter from "./components/IssuesFilter";
import CantWatch from "./components/CantWatch";
import Lag from "./components/Lag";
import Players from "./components/Players";
import Download from "./components/Download";
import SettingsTips from "./components/SettingsTips";
import Faq from "./components/Faq";
import CtaStrip from "./components/CtaStrip";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 flex flex-col">
      <Navbar />
      <main className="flex-1">
        <Hero />
        <QuickIssues />
        <IssuesFilter />
        <CantWatch />
        <Lag />
        <Players />
        <Download />
        <SettingsTips />
        <Faq />
        <CtaStrip />
      </main>
      <Footer />
    </div>
  );
}